import TextEmbed from '@anm/components/TextEmbed';
import { FC } from 'react';

import { EmbedItemProps } from '..';

import { TextWrapper } from './Wrapper';

const TextEmbedPreview: FC<EmbedItemProps> = ({ hostId, embedData }) => {
  const {
    sizes,
    popover: { text }
  } = embedData;

  return (
    <TextWrapper>
      <TextEmbed {...{ hostId, sizes, text }}></TextEmbed>
    </TextWrapper>
  );
};

export default TextEmbedPreview;
